import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import ListGroup from 'react-bootstrap/ListGroup';
import * as consts from '../consts';

// import { AgGridReact } from 'ag-grid-react'
// import 'ag-grid-community/styles/ag-grid.css'
// import 'ag-grid-community/styles/ag-theme-balham.css'
//import 'ag-grid-enterprise'

import 'react-data-grid/lib/styles.css';
import DataGrid from 'react-data-grid';

const MSG_UNLOCK_LEADS = 'Please upgrade to Premium plan to unmask the lead';

const defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    // flex: 1,
    minWidth: 100,
};

function MLeadDetails(props) {
    const [branchesData, setBranchesData] = useState([]);
    const [phonesData, setPhonesData] = useState([]);
    const [emailsData, setEmailsData] = useState([]);
    const [peopleData, setPeopleData] = useState([]);

    const maskRenderer = (params) => {
      return (<span className={(params.maskedrow) ? 'text-blur' : ''}>{params.value}</span>)
    }

    const maskFormatter = (props) => {
      return (<span className={(props.row.maskedrow) ? 'text-blur' : ''}>{props.row[props.column.key]}</span>)
    }

    const urlRenderer = (params) => {
      return ((params.value && params.value !== '') ? (
        (params.data ? params.data.maskedrow : params.maskedrow) ? (
          <div className='d-flex justify-content-center mx-1'>
            <i title={params.title} className={`${params.icon}`} onClick={() => alert(MSG_UNLOCK_LEADS)}></i>
          </div> 
        ) : (
          <div className='d-flex justify-content-center mx-1'>
            <a rel="noreferrer" target='_blank' href={`${params.value}`}><i title={params.title} className={`${params.icon}`}></i></a>
          </div> 
        ) 
        ) : '' )
    }
/*
    const [colDefs, setColDefs] = useState([
        {field: "trimmedname", headerName: "Name", width: 150, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "fulladdress", headerName: "Address", width: 200, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "phone", headerName: "Phone", width: 150, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "marketpresence", headerName: "Presence", width: 50, cellStyle: {textAlign: 'center'}, filter: 'agSetColumnFilter', cellRenderer: maskRenderer},
        {field: "marketreputation", headerName: "Reputation", width: 50, cellStyle: {textAlign: 'center'}, filter: 'agSetColumnFilter', cellRenderer: maskRenderer},
        {field: "city", headerName: "City", width: 50, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "state", headerName: "State/Territory", width: 50, cellStyle: {textAlign: 'center'}, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "category_en", headerName: "Category", width: 150, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
    ]);
    const [phoneColDefs, setPhoneColDefs] = useState([
        {field: "phone", headerName: "Phone", width: 150, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
    ]);

    const [emailColDefs, setEmailColDefs] = useState([
        {field: "email", headerName: "Email", width: 150, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: 'isprefixgeneric', headerName: 'Prefix', filter: 'agSetColumnFilter', width: 100, cellStyle: {textAlign: 'center'}, cellDataType: false, valueFormatter: params => params.value ? 'Generic' : 'Specific', filterParams: {values: [true, false], valueFormatter: params => params.value ? 'Generic' : 'Specific'} },
        {field: 'issuffixgeneric', headerName: 'Suffix', filter: 'agSetColumnFilter', width: 100, cellStyle: {textAlign: 'center'}, cellDataType: false, valueFormatter: params => params.value ? 'Generic' : 'Specific', filterParams: {values: [true, false], valueFormatter: params => params.value ? 'Generic' : 'Specific'} },
    ]);

    const [peopleColDefs, setPeopleColDefs] = useState([
        {field: "name", headerName: "Name", width: 50, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "role_cleaned", headerName: "Role", width: 50, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "email", headerName: "Email", width: 50, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "phone", headerName: "Phone", width: 50, filter: 'agTextColumnFilter', cellRenderer: maskRenderer},
        {field: "linkedin", headerName: "Linkedin", width: 50, filter: 'agTextColumnFilter', cellRenderer: urlRenderer, cellRendererParams: { icon: 'bi bi-linkedin', title: 'LinkedIn' }},
    ]);
*/
    const data = (props.data.length > 0) ? props.data[0] : [];
    const leadid  = (props.mode === 'leads') ? data.id : data.leadid;
    const isMasked = data.maskedrow;    
    const bgImage = consts.getBgUrl(data.ogimage, data.comp_logo, data.gimgurl);
    const bgImageSize = consts.getBgSize(data.ogimage, data.comp_logo, data.gimgurl);
    const homeTitle = data.hometitle && (data.hometitle !== '') ? data.hometitle : data.ogtitle ? data.ogtitle : '';
    const homeDescription = data.homedescription && (data.homedescription !== '') ? data.homedescription : data.ogdescription ? data.ogdescription : '';
    const filterCountry = props.country;

    useEffect(() => {
        props.urd(true);

        axios.post('/getagmegaleaddetails', {leadid, filterCountry, isMasked})
        .then(res => {
            setBranchesData(res.data[0]);
            setPhonesData(res.data[1]);
            const emails=res.data[2].map(email=>{
                email.isprefixgeneric=email.isprefixgeneric?"Generic":"Specific"
                email.issuffixgeneric=email.issuffixgeneric?"Generic":"Specific"
                return email
            })
            setEmailsData(emails);
            setPeopleData(res.data[3]);
            props.urd(false);
        })
    }, [leadid])

    const branchesColDefs= [
    { key: 'trimmedname', name: 'Name', formatter:maskFormatter },
    { key: 'fulladdress', name: 'Address', formatter:maskFormatter },
    { key: 'phone', name: 'Phone', formatter:maskFormatter },
    { key: 'marketpresence', name: 'Presence' },
    { key: 'marketreputation', name: 'Reputation' },
    { key: 'city', name: 'City' },
    { key: 'state', name: 'State/Territory'},
    { key: 'category_en', name: 'Category' }
    ];

    const phoneColDefs=[
        {key: "phone", name: "Phone", formatter:maskFormatter},
    ];

    const emailColDefs = [
        {key: "email", name: "Email", formatter:maskFormatter},
        {key: 'isprefixgeneric', name: 'Prefix'},
        {key: 'issuffixgeneric', name: 'Suffix'},
    ];

    const peopleColDefs = [
        {key: "name", name: "Name", formatter:maskFormatter},
        {key: "role", name: "Role", formatter:maskFormatter},
        {key: "email", name: "Email", formatter:maskFormatter},
        {key: "phone", name: "Phone", formatter:maskFormatter},
        {key: "linkedin", name: "Linkedin", formatter:maskFormatter},
    ];

    const defaultColumnOptions={
        resizable: true
      }

    return (
    <div className="h-100 d-flex flex-column overflow-auto">
        <div className='w-100 d-flex flex-row border flex-fill' style={{maxHeight: "30%"}}>
            <div className='h-100 d-flex flex-column overflow-auto' style={{width: '66%'}}>
                <div className='p-1 border-top bg-primary text-white'>{maskRenderer({maskedrow:data.maskedrow, value:data.trimmedname})}</div>
                {(homeTitle === '') ? '' : (
                <div className='p-1 border-top'>{maskRenderer({maskedrow:data.maskedrow, value:homeTitle})}</div>
                )}
                {(homeDescription === '') ? '' : (
                <div className='p-1 border-top'>{maskRenderer({maskedrow:data.maskedrow, value:homeDescription})}</div>
                )}
            </div>
            <div className='h-100 d-flex flex-column' style={{width: '34%', minHeight: '100px'}}>
                <div style={{height: '100%', backgroundImage: `url(${bgImage})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundColor: '#b8cdfb', backgroundSize: `${bgImageSize}`}}>.</div>
            </div>
        </div>
        <div className='w-100 p-1 bg-primary text-white fw-bold'>Branches{(branchesData.length > 0) ? ` (${branchesData.length})` : ''}</div>
            <div className='w-100 overflow-hidden bg-white' style={{minHeight: "20%"}}>
                {/* <AgGridReact 
                    rowData={branchesData}
                    columnDefs={colDefs} 
                    defaultColDef={defaultColDef}
                    suppressContextMenu={true}
                    animateRows={true}
                /> */}

                <DataGrid 
                    columns={branchesColDefs} 
                    rows={branchesData} 
                    rowHeight={28} 
                    headerRowHeight={32} 
                    className='h-100 w-100 rdg-light' 
                    style={{fontSize:'12px'}}
                    defaultColumnOptions={defaultColumnOptions}
                />
            </div>
        <div className='w-100 p-1 bg-primary text-white fw-bold'>People{(peopleData.length > 0) ? ` (${peopleData.length})` : ''}</div>
        <div className='w-100 overflow-auto bg-white' style={{minHeight: "20%"}}>
            {/* <AgGridReact 
                rowData={peopleData}
                columnDefs={peopleColDefs}
                defaultColDef={defaultColDef}
                suppressContextMenu={true}
                animateRows={true}
            /> */}
            <DataGrid 
                    columns={peopleColDefs} 
                    rows={peopleData} 
                    rowHeight={28} 
                    headerRowHeight={32} 
                    className='h-100 w-100 rdg-light' 
                    style={{fontSize:'12px'}}
                    defaultColumnOptions={defaultColumnOptions}
                />
        </div>
        <div className='w-100' >
            <div className='p-1 bg-primary text-white fw-bold'>Phone Numbers{(phonesData.length > 0) ? ` (${phonesData.length})` : ''}</div>
        </div>
        <div className='w-100 overflow-auto bg-white' style={{minHeight: "20%"}}>
            {/* <AgGridReact 
                rowData={phonesData}
                columnDefs={phoneColDefs}
                defaultColDef={defaultColDef}
                suppressContextMenu={true}
                animateRows={true}
            /> */}
            <DataGrid 
                    columns={phoneColDefs} 
                    rows={phonesData} 
                    rowHeight={28} 
                    headerRowHeight={32} 
                    className='h-100 w-100 rdg-light' 
                    style={{fontSize:'12px'}}
                    defaultColumnOptions={defaultColumnOptions}
                />
        </div>
        <div className='w-100' >
            <div className='p-1 bg-primary text-white fw-bold'>Email IDs{(emailsData.length > 0) ? ` (${emailsData.length})` : ''}</div>
        </div>
        <div className='w-100 overflow-auto bg-white' style={{minHeight: "20%"}}>
            {/* <AgGridReact 
                rowData={emailsData}
                columnDefs={emailColDefs}
                defaultColDef={defaultColDef}
                suppressContextMenu={true}
                animateRows={true}
            /> */}
            <DataGrid 
                    columns={emailColDefs} 
                    rows={emailsData} 
                    rowHeight={28} 
                    headerRowHeight={32} 
                    className='h-100 w-100 rdg-light' 
                    style={{fontSize:'12px'}}
                    defaultColumnOptions={defaultColumnOptions}
                />
        </div>
    </div>
    )
}

export default MLeadDetails;